import React from 'react'
import { LinkButton } from '@/atoms/Button'
import { ParagraphMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

export interface HideEmailSignInExperimentComponentProps {
  loginUrl: string
  isLATAM: boolean
  trackLoginStarted: () => void
}

export const HideEmailSignInExperimentComponent: React.FC<HideEmailSignInExperimentComponentProps> = ({
  loginUrl,
  trackLoginStarted,
  isLATAM = false,
}) => {
  const { t } = useTranslate('tickets')
  if (!isLATAM) {
    return (
      <LinkButton className="w-full" variant="black" href={loginUrl} onClick={() => trackLoginStarted()}>
        <ParagraphMD className="mx-auto" weight="semibold">
          {t('signUpForFree', 'Sign up for Free / Login')}
        </ParagraphMD>
      </LinkButton>
    )
  }
}
